import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

/**
 * Scroll-reveal for the pricing section: the intro column fades up, then the
 * plan cards (Payment Checkup / Payment advice) stagger in.
 * @param {HTMLElement} section
 */
function bindPricingReveal(section) {
	const intro = section.querySelector('.pricing__intro');
	const plans = [...section.querySelectorAll('.pricing__plan')];

	if (!intro && !plans.length) {
		return null;
	}

	const targets = [intro, ...plans].filter(Boolean);
	const timeline = gsap.timeline({ paused: true });

	if (intro) {
		timeline.from(
			intro,
			{
				autoAlpha: 0,
				y: 40,
				duration: 0.7,
				ease: 'power3.out',
			},
			0,
		);
	}

	if (plans.length) {
		timeline.from(
			plans,
			{
				autoAlpha: 0,
				y: 56,
				scale: 0.96,
				duration: 0.8,
				ease: 'power3.out',
				stagger: 0.15,
			},
			intro ? 0.2 : 0,
		);
	}

	const trigger = ScrollTrigger.create({
		trigger: section,
		start: 'top 78%',
		once: true,
		onEnter: () => timeline.play(),
	});

	return () => {
		trigger.kill();
		timeline.kill();
		gsap.set(targets, { clearProps: 'opacity,visibility,transform' });
	};
}

export function initPricingRevealAnimation() {
	const sections = document.querySelectorAll('.js-pricing-section');

	if (!sections.length) {
		return;
	}

	const cleanups = [];

	gsap.matchMedia().add('(prefers-reduced-motion: no-preference)', () => {
		sections.forEach((section) => {
			const cleanup = bindPricingReveal(section);

			if (cleanup) {
				cleanups.push(cleanup);
			}
		});

		return () => {
			cleanups.forEach((fn) => fn());
		};
	});
}
